export default {
  description: state => state.description,
  products: state => state.products,
  tpl: state => state.tpl,
  productsCount: state => state.total,
  productsPerPage: state => state.productsPerPage,
  breadcrumb: state => {
    var _state$description;
    return ((_state$description = state.description) === null || _state$description === void 0 ? void 0 : _state$description.breadcrumb) || null;
  }
};